import React, { Children, Component } from "react";
import PropTypes from "prop-types";
import {
  reduxForm,
  getFormAsyncErrors,
  getFormSyncErrors,
  getFormSubmitErrors,
  formValueSelector,
  change
} from "redux-form";
import { red500 } from "material-ui/styles/colors";
import { connect } from "react-redux";
import compose from "recompose/compose";
import { Tabs, Tab } from "material-ui/Tabs";
import muiThemeable from "material-ui/styles/muiThemeable";
import Snackbar from "material-ui/Snackbar";
import { Toolbar, GET_ONE } from "admin-on-rest";
import getDefaultValues from "../../components/form/getDefaultValues";
import { RestApiShortUrl, RestClient } from "../../restClient";
import { ValuesForm } from "../../components";
import FormVariants from "./FormVariants";
import FormImages from "./FormImages";
import FormDescriptions from "./FormDescriptions";

const getStyles = theme => ({
  form: { padding: "0 1em 3em 1em" },
  // TODO: The color will be taken from another property in MUI 0.19 and later
  errorTabButton: { color: theme.textField.errorColor }
});

export class TabbedForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      slug: props.record.slug,
      category_id: props.record.category_id,
      open: false,
      message: "The Slug already have",
      categories: {}
    };
  }
  componentWillMount() {
    this.getCategories();
  }

  handleRequestClose = () => {
    this.setState({
      open: false
    });
  };

  getCategories() {
    const categoryID = this.props.record.category_id;
    RestClient(GET_ONE, "categories", { id: categoryID })
      .then(items => {
        if (items.data && items.data.name) {
          this.setState({
            categories: items.data
          });
        }
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSlug = (values, redirect) => {
    RestApiShortUrl(values.slug)
      .then(response => {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.json();
      })
      .then(data => {
        if (!data.exists) {
          this.props.save(values, redirect);
          // this.props.handleSubmit(values => this.props.save(values, redirect));
        } else {
          this.setState({
            open: true,
            message: "The Slug already have"
          });
        }
      })
      .catch(e => {
        this.setState({
          open: true,
          message: "Please try again"
        });
        console.error(e);
      });
  };
  handleChange = value => {
    this.setState({ value });
  };

  handleSubmitWithRedirect = (redirect = this.props.redirect) =>
    this.props.handleSubmit(values => {
      if (this.state.slug === values.slug) {
        this.props.save(values, redirect);
      } else {
        this.getSlug(values, redirect);
      }
    });

  render() {
    const {
      children,
      contentContainerStyle,
      invalid,
      muiTheme,
      submitOnEnter,
      tabsWithErrors,
      toolbar,
      translate,
      version
    } = this.props;

    const styles = getStyles(muiTheme);
    return (
      <div>
        <form className="tabbed-form">
          <div style={styles.form} key={version}>
            <Tabs
              value={this.state.value}
              onChange={this.handleChange}
              contentContainerStyle={contentContainerStyle}
            >
              <Tab
                className="form-tab"
                label={"main"}
                value={0}
                buttonStyle={
                  tabsWithErrors.includes("main") && this.state.value !== 0
                    ? styles.errorTabButton
                    : null
                }
              >
                {React.cloneElement(children, {
                  translate,
                  ...this.props,
                  refenceCategories: this.state.categories
                })}
              </Tab>
              <Tab
                className="form-tab"
                label={"variants"}
                value={1}
                buttonStyle={
                  tabsWithErrors.includes("variants") && this.state.value !== 1
                    ? styles.errorTabButton
                    : null
                }
              >
                <FormVariants label={"variants"} {...this.props} />
              </Tab>
              <Tab
                className="form-tab"
                label={"images"}
                value={2}
                buttonStyle={
                  tabsWithErrors.includes("images") && this.state.value !== 2
                    ? styles.errorTabButton
                    : null
                }
              >
                <FormImages label={"images"} {...this.props} />
              </Tab>
              <Tab
                className="form-tab"
                label={"descriptions"}
                value={3}
                buttonStyle={
                  tabsWithErrors.includes("descriptions") &&
                  this.state.value !== 3
                    ? styles.errorTabButton
                    : null
                }
              >
                <FormDescriptions
                  label={"descriptions"}
                  {...this.props}
                  tabIndex={this.state.value}
                />
              </Tab>
            </Tabs>
          </div>
          {toolbar &&
            React.cloneElement(toolbar, {
              handleSubmitWithRedirect: this.handleSubmitWithRedirect,
              invalid,
              submitOnEnter
            })}
        </form>
        <ValuesForm isDebug={false} />
        <Snackbar
          open={this.state.open}
          message={this.state.message}
          autoHideDuration={4000}
          bodyStyle={{ backgroundColor: red500 }}
          onRequestClose={this.handleRequestClose}
        />
      </div>
    );
  }
}

TabbedForm.propTypes = {
  basePath: PropTypes.string,
  children: PropTypes.node,
  contentContainerStyle: PropTypes.object,
  defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  handleSubmit: PropTypes.func, // passed by redux-form
  invalid: PropTypes.bool,
  muiTheme: PropTypes.object.isRequired,
  record: PropTypes.object,
  redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  resource: PropTypes.string,
  save: PropTypes.func, // the handler defined in the parent, which triggers the REST submission
  submitOnEnter: PropTypes.bool,
  tabsWithErrors: PropTypes.arrayOf(PropTypes.string),
  toolbar: PropTypes.element,
  translate: PropTypes.func,
  validate: PropTypes.func,
  version: PropTypes.number
};

TabbedForm.defaultProps = {
  contentContainerStyle: { borderTop: "solid 1px #e0e0e0" },
  submitOnEnter: true,
  toolbar: <Toolbar />
};

const selector = formValueSelector("record-form");

const collectErrors = state => {
  const syncErrors = getFormSyncErrors("record-form")(state);
  const asyncErrors = getFormAsyncErrors("record-form")(state);
  const submitErrors = getFormSubmitErrors("record-form")(state);

  return {
    ...syncErrors,
    ...asyncErrors,
    ...submitErrors
  };
};

export const findTabsWithErrors = (
  state,
  props,
  collectErrorsImpl = collectErrors
) => {
  const errors = collectErrorsImpl(state);

  return Children.toArray(props.children).reduce((acc, child) => {
    const inputs = Children.toArray(child.props.children);

    if (inputs.some(input => errors[input.props.source])) {
      return [...acc, child.props.label];
    }

    return acc;
  }, []);
};

const enhance = compose(
  connect(
    (state, props) => {
      const children = Children.toArray(props.children).reduce(
        (acc, child) => [...acc, ...Children.toArray(child.props.children)],
        []
      );
      const variant = selector(state, "variant");
      const nameProduct = selector(state, "name");
      const priceProduct = selector(state, "price");
      const advancedPrice = selector(state, "advanced_price");
      const tagsProduct = selector(state, "tags");
      const photosProduct = selector(state, "photos");
      const collections = selector(state, "collections");
      const brandProduct = selector(state, "brand");
      const slugProduct = selector(state, "slug");
      return {
        tabsWithErrors: findTabsWithErrors(state, props),
        initialValues: getDefaultValues(state, { ...props, children }),
        variant,
        nameProduct,
        priceProduct,
        tagsProduct,
        photosProduct,
        advancedPrice,
        collections,
        brandProduct,
        slugProduct
      };
    },
    {
      updatePhotos: photos => change("record-form", "photos", photos),
      updateContent: content => change("record-form", "content", content)
    }
  ),
  reduxForm({
    form: "record-form",
    enableReinitialize: true
  }),
  muiThemeable()
);

export default enhance(TabbedForm);



// WEBPACK FOOTER //
// ./src/products/form/TabbedForm.js